import axios from '../Backend';


export const getExtensions = async () => {
    try {
        return (await axios.get('/extensions/getExtensions')).data
    } catch (e) {
        console.log('getExtensions fail')
        console.log(JSON.stringify(e))
        return e
    }

}

export const setOnlineAgent = async (device) => {
    if (!device) return 'Device not selected'
    const query = '?device=' + device
    return await axios.get('/extensions/setOnlineAgent' + query);
}

export const getCallForwardingAlways = async () => {
    const res = await axios.get('/api/v2/extensions/always-forward-call')
    const resData = res.data.data.extensionForwardStatus
    return resData
}

export const setCallForwardingAlways = async (telephone) => {
    const reqBody = {
        forwardToPhoneNumber: telephone
    }
    return await axios.patch('/api/v2/extensions/always-forward-call', reqBody);
}